import React, { useMemo, useState, useEffect } from "react";
import Customtable from "../../helper/Customtable";
import { right } from "@popperjs/core";
import Swal from 'sweetalert2';
import { post } from "../../helper/api_helper"
const Menu = () => {
  useEffect(() => {
    document.title = "User | TCC";
  }, []);

  const columns = useMemo(
    () => [
      {
        header: 'Actions',
        cell: ({ row }) => (
          <i
            className="ri-file-edit-fill text-primary cursor-pointer"
            onClick={() => handleEdit(row)}
            title="Edit"
            style={{ fontSize: "18px" }}
          />
        ),
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        header: 'Menu Name',
        accessorKey: 'menu_name',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Is Child',
        accessorKey: 'is_child',
        enableColumnFilter: false,
        enableSorting: true,
        label_condition: 'checkbox',
      },
      {
        header: 'Parent Menu Name',
        accessorKey: 'parent_menu_name',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Menu Icon',
        accessorKey: 'menu_icon',
        enableColumnFilter: false,
        enableSorting: true,
        label_condition: 'icon',
      },
      {
        header: 'Menu URL',
        accessorKey: 'menu_url',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Menu Order',
        accessorKey: 'menu_order',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Status',
        accessorKey: 'status',
        enableColumnFilter: false,
        enableSorting: true,
        label_condition: 'status',
      },
    ],
    []
  );
  const initialFormState = {
    menu_id: 0,
    menu_name: '',
    is_child: '0',
    parent_menu_id: '0',
    menu_icon: '',
    menu_url: '',
    menu_order: '',
    status: 0
  };

  const [menuList, setMenuList] = useState([]);
  const [formData, setFormData] = useState(initialFormState);
  const [currentPage, setCurrentPage] = useState(0);
  const fetchData = async () => {
    try {
      const response = await post("settings/menu_list");
      if (response.status === 200) {
        setMenuList(response.data);
      } else {
        showAlert('error', response.status, response.message);
      }
    } catch (err) {
      showAlert('error', 'Unexpected Error', err.message);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const handleEdit = (row) => {
    setFormData({
      menu_id: row.menu_id,
      menu_name: row.menu_name,
      is_child: row.is_child.toString(),
      parent_menu_id: row.parent_menu_id || '0',
      menu_icon: row.menu_icon,
      menu_url: row.menu_url,
      menu_order: row.menu_order,
      status: row.status
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const showAlert = (icon, title, text, timer = 2000) => {
    Swal.fire({ icon, title, text: text || 'Something went wrong.', timer, showConfirmButton: false });
  };
  const [validated, setValidated] = useState(false);
  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      showAlert('error', 'Oops...', 'Please fill in all required fields.');
      setValidated(true);
    } else {
      try {
        setValidated(false);
        const response = await post("settings/menu", formData);
        if (response.status === 200) {
          showAlert('success', 'Menu', response.message);
          fetchData();
          setFormData(initialFormState);
        } else {
          showAlert('error', response.status, response.message);
        }
      } catch (err) {
        showAlert('error', 'Unexpected Error', err.message);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-lg-3">
          <div className="card">
            <form noValidate className={validated ? "was-validated" : ""} onSubmit={handleSubmit}>
              <div className="card-header">
                <h5 className="card-title mb-0">Menu</h5>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-sm-12">
                    <label>Menu Name</label>
                    <input
                      name="menu_name"
                      className="form-control"
                      placeholder="Enter Username"
                      type="text"
                      id="menu_name"
                      value={formData.menu_name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-sm-12">
                    <label>Is Child</label>
                    <select
                      className="form-control"
                      name="is_child"
                      value={formData.is_child}
                      onChange={handleChange}
                    >
                      <option value="0">No</option>
                      <option value="1">Yes</option>
                    </select>
                  </div>

                  <div className="col-sm-12">
                    <label>Parent Name</label>
                    <select
                      className="form-control"
                      name="parent_menu_id"
                      value={formData.parent_menu_id}
                      onChange={handleChange}
                    >
                      <option value="0">-Select-</option>
                      {menuList.map((menu) => (
                        <option key={menu.menu_id} value={menu.menu_id}>
                          {menu.menu_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-sm-12">
                    <label>Menu Icon</label>
                    <input
                      type="text"
                      className="form-control"
                      name="menu_icon"
                      value={formData.menu_icon}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-sm-12">
                    <label>Menu URL</label>
                    <input
                      type="text"
                      className="form-control"
                      name="menu_url"
                      value={formData.menu_url}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-sm-12">
                    <label>Menu Order</label>
                    <input
                      type="text"
                      className="form-control"
                      name="menu_order"
                      value={formData.menu_order}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-sm-12">
                    <label>Status</label>
                    <select
                      className="form-control"
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option value="0">Active</option>
                      <option value="1">In-Active</option>

                    </select>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <div className="row">
                  <div className="col-md-12">
                    <button type="submit" className="btn btn-primary btn-sm" style={{ float: right }}>SAVE</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-lg-9">
          <div className="card basic-data-table">
            <div className="card-header">
              <h5 className="card-title mb-0">Menu List</h5>
            </div>
            <div className="card-body">
              <Customtable
                table_title="Menu List"
                columns={columns}
                data={menuList}
                isGlobalFilter={true}
                isPagination={true}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                isExportButton={true}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Menu;
